import React from 'react';
// import { AuthProvider } from './contexts/AuthContext';
import AppRoutes from './routes';
import { SidebarProvider } from "./context/SidebarContext";

const App = () => (
  // <AuthProvider>
  <SidebarProvider>
    <AppRoutes />
  </SidebarProvider>
  // </AuthProvider>
);

export default App;